/*global
    aap
*/
(function ($){

    'use strict';

    var thumb = function(id) {
        //create thumbnail image tag
        var img = aap.stringformat('<img class="youtube-thumb" src="//i.ytimg.com/vi/{0}/default.jpg">', id);

        return img;
    };

    var iframe = function () {

        var iframe = document.createElement('iframe'),
            src,
            srcString = '//www.youtube.com/embed/{0}?autoplay=1&autohide=2';
        //build the string for iframe src
        srcString = srcString + '&border=0&wmode=opaque&enablejsapi=1&controls=1&showinfo=0&theme=light&color=white';
        src = aap.stringformat(srcString, $(this).parent().data('id'));

        //set iframe attributes
        iframe.setAttribute('src', src);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('id', 'youtube-iframe');
        iframe.setAttribute('allowfullscreen', true);
        //replace thumbnail with iframe
        this.parentNode.replaceChild(iframe, this);
    };

    aap.youtube = {};
    aap.youtube.thumb = thumb;
    aap.youtube.iframe = iframe;

    // get number of you tube embeds divs
    var v = document.getElementsByClassName('youtube-player');

    for (var n = 0; n < v.length; n++) {
        //for each of them get id
        var id = $(v[n]).data('id');
        //create an empty div
        var p = document.createElement('div');
        //populate div with video thumbnail
        p.innerHTML = thumb(id);


        //attach event to thumbnail to get youtube iframe
        p.onclick = iframe;
        v[n].appendChild(p);
        if ( $('div.is_owner_edit_p') ) {
            $(v[n]).append('<label class="file" for="video"><span>Replace</span><span class="error" style="display:none;">Oops!</span></label>');    
        }
    }

}(jQuery));
